import { ThrowError } from './errors';

/**
 * Checks if a number is within a specified range.
 * @param value - The number to check.
 * @param min - The minimum value of the range.
 * @param max - The maximum value of the range.
 * @returns `true` if the number is within range; otherwise, `false`.
 */
export const isInRange = (value: number, min: number, max: number): boolean => {
  if (min > max) {
    ThrowError(`min (${min}) couldn't be bigger than max (${max})`);
  }

  return value >= min && value <= max;
};

/**
 * Restricts a number to be within a specified range.
 * @param value - The number to restrict.
 * @param min - The minimum allowed value.
 * @param max - The maximum allowed value. Defaults to `Infinity`.
 * @returns The number restricted to the specified range.
 */
export const getNumberInRange = (value: number, min: number, max: number = Infinity): number => {
  let trunkNumber = value;

  if (min > max) {
    ThrowError(`min (${min}) couldn't be bigger than max (${max})`);
  }

  if (trunkNumber < min) {
    trunkNumber = min;
  } else if (trunkNumber > max) {
    trunkNumber = max;
  }

  return trunkNumber;
};
